import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, BookMarkedIcon, CheckCircleIcon, GiftIcon, TagIcon } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function ValueStackSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id="pricing" className="w-full py-12 sm:py-16 px-4 sm:px-6" style={{
    background: 'linear-gradient(180deg, #0A1628 0%, #0D1F3C 100%)'
  }} data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-8" data-id="element-145">
          <div className="flex justify-center mb-3" data-id="element-146">
            <TagIcon size={28} className="text-gold-warm" data-id="element-147" />
          </div>
          <h2 className="font-cinzel font-bold text-2xl sm:text-3xl md:text-4xl mb-4" style={{
          color: '#FFF8E7'
        }} data-id="element-148">
            ¿Qué Incluye el Bundle de{' '}
            <span className="text-gold-light" data-id="element-149">$297 MXN?</span>
          </h2>
          <div className="divider-gold mx-auto" style={{
          width: '140px'
        }} data-id="element-150" />
        </motion.div>

        {/* Items */}
        <div className="space-y-3 mb-8" data-id="element-151">
          {/* Main product */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex items-start gap-4 p-4 sm:p-5 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(27,58,107,0.6) 0%, rgba(10,22,40,0.8) 100%)',
          border: '2px solid rgba(201,168,76,0.5)'
        }} data-id="element-152">
            <div className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center" style={{
            background: 'rgba(201,168,76,0.2)',
            border: '2px solid #C9A84C'
          }} data-id="element-153">
              <BookOpenIcon size={20} className="text-gold-warm" data-id="element-154" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-155">
              <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-156">
                <CheckCircleIcon size={15} className="text-gold-warm flex-shrink-0" data-id="element-157" />
                <h3 className="font-cinzel font-bold text-sm sm:text-base text-gold-light" data-id="element-158">
                  Ebook "Escudo de Fe" (51 Páginas)
                </h3>
              </div>
              <p className="font-lato text-sm mb-1.5" style={{
              color: 'rgba(255,248,231,0.85)'
            }} data-id="element-159">
                El manual completo con oraciones redactadas palabra por palabra.
              </p>
              <span className="font-lato text-xs font-bold" style={{
              color: 'rgba(201,168,76,0.7)'
            }} data-id="element-160">
                Valor: $497 MXN
              </span>
            </div>
          </motion.div>

          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.35
        }} className="flex items-start gap-4 p-4 sm:p-5 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(27,58,107,0.4) 0%, rgba(10,22,40,0.6) 100%)',
          border: '1px solid rgba(201,168,76,0.3)'
        }} data-id="element-161">
            <div className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center" style={{
            background: 'rgba(201,168,76,0.15)',
            border: '1px solid rgba(201,168,76,0.4)'
          }} data-id="element-162">
              <GiftIcon size={20} className="text-gold-warm" data-id="element-163" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-164">
              <span className="font-cinzel text-xs font-bold px-2 py-0.5 rounded inline-block mb-1" style={{
              background: 'rgba(201,168,76,0.2)',
              color: '#F0D080'
            }} data-id="element-165">
                BONUS #1
              </span>
              <h3 className="font-cinzel font-bold text-sm sm:text-base text-gold-light mb-1" data-id="element-166">
                Calendario de 30 Días de Milagros
              </h3>
              <p className="font-lato text-sm mb-1.5" style={{
              color: 'rgba(255,248,231,0.85)'
            }} data-id="element-167">
                Un PDF para anotar tus peticiones y ver cómo se cumplen.
              </p>
              <span className="font-lato text-xs font-bold" style={{
              color: 'rgba(201,168,76,0.7)'
            }} data-id="element-168">
                Valor: $197 MXN
              </span>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex items-start gap-4 p-4 sm:p-5 rounded-xl" style={{
          background: 'linear-gradient(135deg, rgba(27,58,107,0.4) 0%, rgba(10,22,40,0.6) 100%)',
          border: '1px solid rgba(201,168,76,0.3)'
        }} data-id="element-169">
            <div className="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center" style={{
            background: 'rgba(201,168,76,0.15)',
            border: '1px solid rgba(201,168,76,0.4)'
          }} data-id="element-170">
              <GiftIcon size={20} className="text-gold-warm" data-id="element-171" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-172">
              <span className="font-cinzel text-xs font-bold px-2 py-0.5 rounded inline-block mb-1" style={{
              background: 'rgba(201,168,76,0.2)',
              color: '#F0D080'
            }} data-id="element-173">
                BONUS #2
              </span>
              <h3 className="font-cinzel font-bold text-sm sm:text-base text-gold-light mb-1" data-id="element-174">
                Guía de Salmos de Emergencia
              </h3>
              <p className="font-lato text-sm mb-1.5" style={{
              color: 'rgba(255,248,231,0.85)'
            }} data-id="element-175">
                Qué rezar exactamente en momentos de crisis o miedo intenso.
              </p>
              <span className="font-lato text-xs font-bold" style={{
              color: 'rgba(201,168,76,0.7)'
            }} data-id="element-176">
                Valor: $150 MXN
              </span>
            </div>
          </motion.div>
        </div>

        {/* Price summary */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.65
      }} className="rounded-2xl p-6 sm:p-8 text-center mb-6" style={{
        background: 'linear-gradient(135deg, rgba(27,58,107,0.7) 0%, rgba(10,22,40,0.9) 100%)',
        border: '2px solid rgba(201,168,76,0.6)'
      }} data-id="element-177">
          <p className="font-lato text-xs mb-1" style={{
          color: 'rgba(255,248,231,0.7)'
        }} data-id="element-178">
            VALOR TOTAL
          </p>
          <p className="font-cinzel font-bold text-2xl mb-1" style={{
          color: 'rgba(255,248,231,0.4)',
          textDecoration: 'line-through'
        }} data-id="element-179">
            $844 MXN
          </p>
          <p className="font-lato text-xs mb-2" style={{
          color: 'rgba(255,248,231,0.6)'
        }} data-id="element-180">
            PRECIO ESPECIAL HOY
          </p>
          <p className="font-cinzel font-black text-5xl sm:text-6xl gold-text mb-1" data-id="element-181">
            $297
          </p>
          <p className="font-cinzel font-bold text-lg text-gold-warm" data-id="element-182">MXN</p>
          <div className="flex items-center justify-center gap-2 mt-2" data-id="element-183">
            <svg width="20" height="13" viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg" data-id="element-184">
              <rect width="8" height="16" fill="#006847" data-id="element-185" />
              <rect x="8" width="8" height="16" fill="white" data-id="element-186" />
              <rect x="16" width="8" height="16" fill="#CE1126" data-id="element-187" />
            </svg>
            <span className="font-lato text-xs" style={{
            color: 'rgba(255,248,231,0.6)'
          }} data-id="element-188">
              México
            </span>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.8
      }} className="text-center" data-id="element-189">
          <button className="cta-button pulse-glow inline-flex items-center gap-2 px-5 py-4 rounded-lg text-navy-deep font-cinzel font-bold text-sm sm:text-base uppercase tracking-wide w-full justify-center" style={{
          background: 'linear-gradient(135deg, #C9A84C 0%, #F0D080 50%, #C9A84C 100%)'
        }} aria-label="Descargar Escudo de Fe ahora" data-id="element-190">
            <BookMarkedIcon size={18} className="flex-shrink-0" data-id="element-191" />
            <span data-id="element-192">DESCARGAR "ESCUDO DE FE" AHORA</span>
          </button>
          <PaymentIcons data-id="element-193" />
        </motion.div>
      </div>
    </section>;
}